import { ColumnsType } from 'antd/lib/table'
import { formatRollerDisplay } from '../../../../../helpers/format-roller-display'
import RewindQueueEntry from '../../../../../types/api/rewind-queue-entry'
import ShipmentPosition from '../../../../../types/api/shipment-position'
import { getShipmentFloods } from '../../helpers/get-shipment-floods'
import { MaterialColumnCell } from '../../../flexo/components/cells/material-column-cell'
import DragHandler from '../../../flexo/components/machines-queues/components/machine-queue/components/drag-handler'
import PrintEndTimeCell from '../cells/print-end-time-cell'
import RewindCopiesCell from '../cells/rewind-copies-cell'
import RewindJobNumberCell from '../cells/rewind-job-number-cell'
import ActionsCell from './components/machine-queue/components/actions-cell'

export const columns: ColumnsType<RewindQueueEntry> = [
    { key: 'sort', align: 'center', width: 30, render: () => <DragHandler /> },
    {
        dataIndex: ['rewind_job', 'id'],
        title: 'Номер перемотки',
        width: 70,
        render: (_value, record) => <RewindJobNumberCell rewindJob={record.rewind_job} />,
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'print_job', 'id'],
        title: 'Номер печати',
        width: 95,
        render: (_value, record) => record.rewind_job?.shipment?.print_job?.id || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'id'],
        title: 'Номер отгрузки',
        width: 95,
        render: (_value, record) => record.rewind_job?.shipment?.id || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'client', 'name'],
        title: 'Заказчик',
        render: (_value, record) => record.rewind_job?.shipment?.client?.name || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'materialRequirements'],
        title: 'Материал',
        width: 110,
        render: (_value, record) => (
            <MaterialColumnCell value={record.rewind_job?.shipment?.materialRequirements || []} />
        ),
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'bushing'],
        title: 'Втулка',
        width: 70,
        render: (_value, record) => record.rewind_job?.shipment?.bushing || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'shipment_positions'],
        title: 'Ручьи',
        width: 70,
        render: (_value: ShipmentPosition[], record) => {
            const floods = getShipmentFloods(record.rewind_job?.shipment)

            return floods ?? '—'
        },
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'roller', 'roller'],
        title: 'Вал',
        width: 100,
        render: (_value, record) => {
            const shipment = record.rewind_job?.shipment
            if (!shipment) return '—'

            const roller = shipment.withoutCutting
                ? shipment.virtualStamp?.roller?.roller
                : shipment.stamp?.roller?.roller

            return formatRollerDisplay(roller) ?? '—'
        },
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'shipment_positions'],
        title: 'Тираж',
        width: 110,
        render: (_value, record) => <RewindCopiesCell rewindJob={record.rewind_job} editable />,
    },
    {
        key: 'printEndAt',
        title: 'Время окончания печати',
        width: 90,
        render: (_value, record) => <PrintEndTimeCell shipment={record.rewind_job?.shipment} />,
    },
    {
        dataIndex: 'actions',
        title: '',
        fixed: 'right',
        render: (_value, record) => <ActionsCell rewindQueueEntry={record} />,
    },
]
